module.exports = __webpack_public_path__ + "img/calendar-silver.b1e6ece7.svg";